import React from "react";
import "./chat-bar.css";
import { useNavigate } from "react-router";
import { AnimateSharedLayout, motion } from "framer-motion";
function ChatBar({ setChatInd, chatInd, userid, mentor }) {
  const navigate = useNavigate();
  const spring = {
    type: "spring",
    stiffness: 500,
    damping: 30,
  };
  return (
    <div class="chat-bar">
      <div
        style={{ marginTop: "50px", marginLeft: "50px" }}
        class="profile"
        onClick={() => {
          navigate(-1);
        }}
      >
        <h1 style={{ color: "white" }}>{userid}</h1>
      </div>

      <div style={{ marginTop: "50%" }} class="channels">
        {mentor === 1 ? (
          <div onClick={() => setChatInd(0)}>
            <h3 style={{ color: "white", marginTop: "10%" }}>Mentor Chat</h3>
          </div>
        ) : (
          <AnimateSharedLayout>
            <motion.div    whileHover={{ scale: 1.2 }}
      whileTap={{ scale: 0.9 }} class="chat-sec " onClick={() => setChatInd(0)}>
              {chatInd === 0 ? (
                <motion.div
                  layoutId="outline"
                 style={{backgroundColor:'yellow'}}
                  className="yellow-div"
                >
                  <h3 style={{ color: "black" }}>Announcement</h3>
                </motion.div>
              ) : (
                <motion.div className="black-div">
                  <h3 style={{ color: "white" }}>Announcement</h3>
                </motion.div>
              )}
            </motion.div>
            <motion.div    whileHover={{ scale: 1.2 }}
      whileTap={{ scale: 0.9 }} class="chat-sec" onClick={() => setChatInd(1)}>
              {chatInd === 1 ? (
                <motion.div
                  layoutId="outline"
                 style={{backgroundColor:'yellow'}}
                  className="yellow-div "
                >
                  <h3 style={{ color: "black" }}>Group Chat</h3>
                </motion.div>
              ) : (
                <motion.div className="black-div">
                  <h3 style={{ color: "white" }}>Group Chat</h3>
                </motion.div>
              )}
            </motion.div>
            <motion.div    whileHover={{ scale: 1.2 }}
      whileTap={{ scale: 0.9 }} class="chat-sec" onClick={() => setChatInd(2)}>
              {chatInd === 2 ? (
                <motion.div
                  layoutId="outline"
                 style={{backgroundColor:'yellow'}}
           
                  className="yellow-div"
                >
                  <h3 style={{ color: "black" }}>Mentor Chat</h3>
                </motion.div>
              ) : (
                <motion.div
                  className="black-div"
                  style={{ backgroundColor: "transparent" }}
                >
                  <h3 style={{ color: "white" }}>Mentor Chat</h3>
                </motion.div>
              )}
            </motion.div>
          </AnimateSharedLayout>
        )}
      </div>
    </div>
  );
}
export default ChatBar;
